var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis maintit" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.SEE.DETAILS")))])
          ]),
          _vm._v(" "),
          _c(
            "dd",
            _vm._l(_vm.faqList, function(item, idx) {
              return _c(
                "div",
                {
                  key: _vm.pageName + item.FAQ_ID + idx,
                  staticClass: "view_cont"
                },
                [
                  _c("dl", { staticClass: "view_subject" }, [
                    _c("dt", { staticClass: "subject qna_view" }, [
                      "S" === item.GRADE
                        ? _c("em", { staticClass: "textcolor_urgent" }, [
                            _vm._v(
                              "\n                                    [" +
                                _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) +
                                "]\n                                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.TITLE) +
                          "\n                                "
                      ),
                      _c("span", { staticClass: "in_date" }, [
                        _vm._v(_vm._s(item.REG_DT))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view_question" }, [
                    _c("div", { staticClass: "faq_wrap" }, [
                      _c("div", { staticClass: "ico_faq_a" }, [
                        _c("div", {
                          staticClass: "q_cont",
                          domProps: {
                            innerHTML: _vm._s(_vm.stripHtml(item.QUESTION_DESC))
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "a_cont" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.stripHtml(item.SOLUTION_DESC)
                              )
                            }
                          }),
                          _vm._v(" "),
                          0 < item.ATTCH_CNT
                            ? _c(
                                "span",
                                [
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm._l(_vm.attach, function(file) {
                                    return _c(
                                      "a",
                                      {
                                        key:
                                          file.ENC_ATTCH_FILE_SEQ +
                                          file.ENC_TOKEN,
                                        staticClass: "txt_link",
                                        attrs: {
                                          href: _vm.getDownloadUrl(
                                            file.ENC_ATTCH_FILE_SEQ,
                                            file.ENC_TOKEN
                                          ),
                                          download: "true",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(file.FILE_NM) +
                                            "\n                                            "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e41ab30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e41ab30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/viewFaqPopup.vue
// module id = 3ZZq
// module chunks = 0